// extracted by mini-css-extract-plugin
module.exports = {"Container":"NotFound_Container__3elIk","Status":"NotFound_Status__2CTDB","Message":"NotFound_Message__3jggT"};